import {StyleParamType, createStylesParams} from '@wix/tpa-settings'
import {StyleType} from '@wix/editor-platform-ooi-metadata-resolver'

import {Alignment} from '../../../../../types/createStylesParams'
import {
  ALIGNMENT_DESCRIPTION,
  numberEnumMetadata,
  numberMetadata,
} from '../../../../../utils/builderMetadata'

export type LayoutStylesParams = {
  breadcrumbsAlignment: StyleParamType.Number
  spaceBetweenTitleAndDescription: StyleParamType.Number
  spaceBetweenTextAndForm: StyleParamType.Number
  spaceBetweenFormAndTimeSlots: StyleParamType.Number
  spaceBetweenFormAndAreas: StyleParamType.Number
  spaceBetweenAreasAndTimeSlots: StyleParamType.Number
  sidePadding: StyleParamType.Number
  topBottomPadding: StyleParamType.Number
  buttonPadding: StyleParamType.Number
}

export const layoutStylesParams = createStylesParams<LayoutStylesParams>({
  breadcrumbsAlignment: {
    type: StyleParamType.Number,
    getDefaultValue: () => Alignment.Left,
    metadata: numberEnumMetadata({defaultValue: Alignment.Left}, ALIGNMENT_DESCRIPTION),
  },
  spaceBetweenTitleAndDescription: {
    type: StyleParamType.Number,
    getDefaultValue: () => 20,
    metadata: numberMetadata(StyleType.gap, {defaultValue: 20}),
  },
  spaceBetweenTextAndForm: {
    type: StyleParamType.Number,
    getDefaultValue: () => 40,
    metadata: numberMetadata(StyleType.gap, {defaultValue: 40}),
  },
  spaceBetweenFormAndTimeSlots: {
    type: StyleParamType.Number,
    getDefaultValue: () => 80,
    metadata: numberMetadata(StyleType.gap, {defaultValue: 80}),
  },
  spaceBetweenFormAndAreas: {
    type: StyleParamType.Number,
    getDefaultValue: () => 120,
    metadata: numberMetadata(StyleType.gap, {defaultValue: 120}),
  },
  spaceBetweenAreasAndTimeSlots: {
    type: StyleParamType.Number,
    getDefaultValue: () => 40,
    metadata: numberMetadata(StyleType.gap, {defaultValue: 40}),
  },
  sidePadding: {
    type: StyleParamType.Number,
    getDefaultValue: (params) => (params.isMobile ? 0 : 40),
    metadata: numberMetadata(StyleType.padding, {defaultValue: 40, mobileDefaultValue: 0}),
  },
  topBottomPadding: {
    type: StyleParamType.Number,
    getDefaultValue: (params) => (params.isMobile ? 20 : 40),
    metadata: numberMetadata(StyleType.padding, {defaultValue: 40, mobileDefaultValue: 20}),
  },
  buttonPadding: {
    type: StyleParamType.Number,
    getDefaultValue: () => 20,
    metadata: numberMetadata(StyleType.padding, {defaultValue: 20}),
  },
})

export type AreasLayoutStylesParams = {
  spaceBetweenAreaCards: StyleParamType.Number
  areasTopBottomPadding: StyleParamType.Number
  areasSidePadding: StyleParamType.Number
}

export const areasLayoutStylesParams = createStylesParams<AreasLayoutStylesParams>({
  spaceBetweenAreaCards: {
    type: StyleParamType.Number,
    getDefaultValue: () => 20,
    metadata: numberMetadata(StyleType.gap, {defaultValue: 20}),
  },
  areasTopBottomPadding: {
    type: StyleParamType.Number,
    getDefaultValue: () => 16,
    metadata: numberMetadata(StyleType.padding, {defaultValue: 16}),
  },
  areasSidePadding: {
    type: StyleParamType.Number,
    getDefaultValue: () => 16,
    metadata: numberMetadata(StyleType.padding, {defaultValue: 16}),
  },
})
